<template>
    <div class="row ps-5">
        <div class="col-sm-6">
            <p class="font-weight-bold p-header lead mb-0 p-2 mb-2">Şəxsi məlumat</p>

            <table class="table-info mt-2">
                <tr>
                    <td class="td-info-1">
                        Tam adı
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.name }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        FIN
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.pin }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Doğum tarixi
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.dob }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Ünvan
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.address }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Telefon
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.phone }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Email
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.mail }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Cinsi
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.sex }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Boy
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.height }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Çəki
                    </td>
                    <td class="td-info-2">
                        {{ data.insuredPer.weight }}
                    </td>
                </tr>
            </table>

            <!-- <p class="font-weight-bold mt-3 p-header lead mb-0 p-2 mb-1">Faydalanan</p>
             
            <table class="table-info mt-2">
                <tr>
                    <td class="td-info-1">
                        Tam adı
                    </td>
                    <td class="td-info-2">
                        {{ data.beneficiary.name }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Ünvan
                    </td>
                    <td class="td-info-2">
                        {{ data.beneficiary.address }}
                    </td>
                </tr>
            </table> -->
        </div>
        <div class="col-sm-6">
            <p class="font-weight-bold p-header lead p-2 mb-2">Məbləğ</p>

            <table class="table-info mt-2">
                <tr>
                    <td class="td-info-1">
                        Bank vergi dərəcəsi
                    </td>
                    <td class="td-info-2">
                        {{ data.bankTax }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Risk məbləğ
                    </td>
                    <td class="td-info-2">
                        {{ data.riskSum }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Məbləğ limiti
                    </td>
                    <td class="td-info-2">
                        {{ data.sumLimit }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Beta cost
                    </td>
                    <td class="td-info-2">
                        {{ data.betaCost }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Sığorta məbləğ / Sığorta haqqı
                    </td>
                    <td class="td-info-2">
                        {{ data.sumInsured }} / {{ data.premium }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Ödəyici haqqı / Ödəyici məbləği
                    </td>
                    <td class="td-info-2">
                        {{ data.holderPremium }} / {{ data.holderSumInsured }}
                    </td>
                </tr>
            </table>
            <p class="font-weight-bold p-header lead mb-0 mt-3 p-2 mb-2">Deposit</p>

            <table class="table-info mt-2">
                <tr>
                    <td class="td-info-1">
                        Deposit
                    </td>
                    <td class="td-info-2">
                        {{ data.depNumber }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Depozit dərəcəsi / Klient depozit dərəcəsi
                    </td>
                    <td class="td-info-2">
                        {{ data.depRate }} / {{ data.depRateClient }}
                    </td>
                </tr>
            </table>
            <p class="font-weight-bold mt-3 p-header lead mb-0 p-2 mb-1">Əlavə risklər</p>

            <table class="table-info mt-2">
                <tr>
                    <td class="td-info-1">
                        III dərəcə / II dərəcə
                    </td>
                    <td class="td-info-2">
                        {{ data.coverDegree3 }} / {{ data.coverDegree2 }}
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <br>
    <div class="row pt-2 ps-5 pe-5">
        <div class="table-responsive">
            <p class="font-weight-bold p-header p-2 w-100 lead mb-3">Sığorta olunanın çəkilmiş xəstəliklərə
                tutulması
            </p>
            <el-table size="large" border :data="this.data2" class="el-table-css" style="width: 100%">
                <el-table-column width="85">
                    <template #default="scope">
                        <div style="text-align: center;">
                            <i v-if="scope.row.check == true" style="font-size: 18px;"
                                class="bi bi-check-lg text-excel"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="descr" />
            </el-table>
            <p class="font-weight-bold p-header mt-4 p-2 w-100 lead mb-3">
                Sığorta olunanda sadalanan xəstəliklər və ya simptomlar mövcuddur
            </p>
            <el-table border size="large" :data="this.data3" class="el-table-css" style="width: 100%">
                 <el-table-column width="85">
                    <template #default="scope">
                        <div style="text-align: center;">
                            <i v-if="scope.row.check == true" style="font-size: 18px;" class="bi bi-check-lg text-excel"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="descr" />
            </el-table>
        </div>
    </div>
        <br>
</template>
<script>
export default {
    props: {
        data: Object,
        data2: Array,
        data3: Array
    },
    data() {
        return {
            loading: false
        }
    }
}
</script>
<style scoped>

::v-deep(.el-table thead){
    display: none;
}

</style>